export default {
    your_account: "Your account could not be confirmed",
    wait_while: "Wait while we confirm your account",
    the_code: "The code in the link is invalid.",
    back_settings: "Back to settings"
};
